<template>
  <div class="scroll" ref="wrapper">
    <div class="content" ref="content" :class="{ 'x-content': x }">
      <slot></slot>
      <a class="scroll-bottom" ref="scrollBottom"></a>
    </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";
export default {
  name: "scroll",
  props: {
    x: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      option: {
        scrollX: true, // 横向滚动
        eventPassthrough: "horizontal",
        scrollbar: {
          fade: true,
          interactive: true
        }, // 滚动条显示
        bounce: false, // 回弹
        mouseWheel: {
          speed: 20,
          invert: false,
          easeTime: 500
        }
      },
      scroll: ""
    };
  },
  mounted() {
    if (this.x) {
      this.option.eventPassthrough = "";
    }
    this.$nextTick(this.init);
  },
  beforeDestroy() {
    this.scroll.destroy();
  },
  methods: {
    init() {
      this.scroll = new BScroll(this.$refs.wrapper, this.option);
    },
    refresh() {
      this.scroll.refresh();
      this.$nextTick(this.scrollTo);
    },
    onlyrefresh() {
      this.scroll.refresh();
    },
    enable() {
      this.scroll.enable();
    },
    disable() {
      this.scroll.disable();
    },
    // 滚动到底部
    scrollTo() {
      this.scroll.scrollToElement(this.$refs.scrollBottom, 300);
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll {
  height: 100%;
  overflow: hidden;
  position: relative;
  .x-content {
    // 兼容 edge
    display: inline-block;
    width: fit-content;
  }
}
</style>
